export default {
  "content": "<path d=\"M3 3h18c1.11 0 2 .89 2 2v14c0 1.11-.89 2-2 2H3c-1.11 0-2-.89-2-2V5c0-1.11.89-2 2-2zm1 16.02h16c.55 0 1-.45 1-1V5.98c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v12.04c0 .55.45 1 1 1z\" clip-rule=\"evenodd\"/><path stroke=\"#fff\" stroke-width=\".3\" d=\"M15.929 8.077a.754.754 0 00-1.068 0s0 0 0 0L12 10.933l-2.862-2.86s0 0 0 0a.754.754 0 00-1.068 0l.106.105-.106-.106a.754.754 0 000 1.068L10.932 12l-2.86 2.86a.754.754 0 101.067 1.069L12 13.068l2.86 2.86a.754.754 0 101.069-1.067L13.068 12l2.86-2.861a.758.758 0 000-1.062z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#fff",
    "fill-rule": "evenodd",
    "viewBox": "0 0 24 24"
  }
};